import PropTypes from "prop-types"
import { useRemarkSync } from "react-remark"
import { Link } from "react-router-dom"

import Button from "components/ui/button"

const components = {
  a: ({ href, ...props }) => (
    <Button asChild text underline variant="secondary">
      <Link target="_blank" to={href} {...props} />
    </Button>
  ),
  h1: ({ ...props }) => <h1 className="h2" {...props} />,
  h2: ({ ...props }) => <h2 className="h3" {...props} />,
  h3: ({ ...props }) => <h3 className="body-lg" {...props} />,
  p: ({ ...props }) => <p className="body" {...props} />,
}

const FAQMarkdown = ({ children }) => {
  const markdownContent = useRemarkSync(children, {
    rehypeReactOptions: { components },
    suppressHydrationWarning: true,
  })

  return markdownContent
}

FAQMarkdown.propTypes = {
  children: PropTypes.string,
}

export default FAQMarkdown
